import { render, staticRenderFns } from "./MediaView.vue?vue&type=template&id=32f446cd&scoped=true"
import script from "./MediaView.vue?vue&type=script&lang=js"
export * from "./MediaView.vue?vue&type=script&lang=js"
import style0 from "./MediaView.vue?vue&type=style&index=0&id=32f446cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f446cd",
  null
  
)

export default component.exports